<template>
    <div class="wow fadeInLeft relative z-10">
        <div class="item">
            <div class="day count">
                {{ countdownDays }}
            </div>
            <div class="lbl lbl-day">
                DAYs
            </div>
        </div>
        <div class="item">
            <div class="hour count">
                {{ countdownHours }}
            </div>
            <div class="lbl lbl-hour">
                hours
            </div>
        </div>
        <div class="item">
            <div class="min count">
                {{ countdownMinutes }}
            </div>
            <div class="lbl lbl-minute">
                minutes
            </div>
        </div>
        <div class="item">
            <div class="min count">
                {{ countdownSeconds }}
            </div>
            <div class="lbl lbl-seconds">
                seconds
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'Countdown',
    props: {
        date: {
            type: String,
        },
        now: {
            type: String,
        },
    },
    data() {
        return {
            countdownTime: null,
            countdownDays: '00',
            countdownHours: '00',
            countdownMinutes: '00',
            countdownSeconds: '00',
            countdownEnd: false,
            diff: 0,
        };
    },
    mounted() {
        this.checkCountdown();
        this.diff = moment(this.now).diff(moment());
    },
    methods: {
        checkCountdown() {
            let diff = moment(this.date).diff(moment()) + this.diff;
            diff /= 1000;
            this.countdownTime = diff;
            if (diff < 0) {
                this.countdownEnd = true;
            } else {
                const days = Math.floor(diff / (60 * 60 * 24));
                this.countdownDays = days ? days.toString() : '00';
                const hours = Math.floor((diff / (60 * 60)) % 24);
                this.countdownHours = (days || hours) ? hours.toString().padStart(2, '0') : '00';
                this.countdownMinutes = !isNaN(Math.floor((diff / 60) % 60)) ? Math.floor((diff / 60) % 60).toString().padStart(2, '0') : '00';
                this.countdownSeconds = !isNaN(Math.trunc(diff % 60)) ? Math.trunc(diff % 60).toString().padStart(2, '0') : '00';
            }

            setTimeout(() => {
                this.checkCountdown();
            }, 1000);
        },
    },
};
</script>
